import { useState } from "react";
import { clubApi } from "../api/club.service";
import { ClubPayload } from "../types";

export const useEdit = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (id: string, payload: ClubPayload) => {
    try {
      setLoading(true);

      const response: any = await clubApi.update(id, payload);

      return {
        success: true,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Edit club failed:", err);

      return {
        success: false,
        message: err?.response?.data?.error?.message_vi || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
